// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__193Ws","header":"PatientQuestionnaire_header__8vrcV","info":"PatientQuestionnaire_info__31mDJ"};